import { UserAction, } from '@thoughtspot/metrics';
import { getCurrentOrgId } from '@thoughtspot/session-service';
import { BasePageContext } from "../../../../contexts/basepage-context";
const buildTrackers = (metricsService) => {
    const emit = (eventKey, props) => {
        metricsService?.collectEvent(new UserAction(eventKey), {
            adminSection: 'users',
            userRole: getCurrentOrgId() === -1 ? 'cluster_admin' : 'org_admin',
            ...props,
        });
    };
    return {
        tabViewed: (props) => emit('ADMIN_USER_TAB_VIEWED', props),
        listSearched: (props) => emit('ADMIN_USER_LIST_SEARCHED', props),
        listFiltered: (props) => emit('ADMIN_USER_LIST_FILTERED', props),
        listSorted: (props) => emit('ADMIN_USER_LIST_SORTED', props),
        listPaginated: (props) => emit('ADMIN_USER_LIST_PAGINATED', props),
        createClicked: (props) => emit('ADMIN_USER_CREATE_CLICKED', props),
        createDialogViewed: (props) => emit('ADMIN_USER_CREATE_DIALOG_VIEWED', props),
        createStepCompleted: (props) => emit('ADMIN_USER_CREATE_STEP_COMPLETED', props),
        createSubmitted: (props) => emit('ADMIN_USER_CREATE_SUBMITTED', props),
        createSucceeded: (props) => emit('ADMIN_USER_CREATE_SUCCEEDED', props),
        createFailed: (props) => emit('ADMIN_USER_CREATE_FAILED', props),
        createCancelled: (props) => emit('ADMIN_USER_CREATE_CANCELLED', props),
        detailsViewed: (props) => emit('ADMIN_USER_DETAILS_VIEWED', props),
        editClicked: (props) => emit('ADMIN_USER_EDIT_CLICKED', props),
        editSaved: (props) => emit('ADMIN_USER_EDIT_SAVED', props),
        editFailed: (props) => emit('ADMIN_USER_EDIT_FAILED', props),
        statusChanged: (props) => emit('ADMIN_USER_STATUS_CHANGED', props),
        orgAssigned: (props) => emit('ADMIN_USER_ORG_ASSIGNED', props),
        orgUnassigned: (props) => emit('ADMIN_USER_ORG_UNASSIGNED', props),
        groupAssigned: (props) => emit('ADMIN_USER_GROUP_ASSIGNED', props),
        groupUnassigned: (props) => emit('ADMIN_USER_GROUP_UNASSIGNED', props),
        deleteClicked: (props) => emit('ADMIN_USER_DELETE_CLICKED', props),
        deleteConfirmed: (props) => emit('ADMIN_USER_DELETE_CONFIRMED', props),
        deleteSucceeded: (props) => emit('ADMIN_USER_DELETE_SUCCEEDED', props),
        deleteFailed: (props) => emit('ADMIN_USER_DELETE_FAILED', props),
        deleteCancelled: (props) => emit('ADMIN_USER_DELETE_CANCELLED', props),
        bulkActionPerformed: (props) => emit('ADMIN_USER_BULK_ACTION_PERFORMED', props),
        exported: (props) => emit('ADMIN_USER_EXPORTED', props),
        userInvited: (props) => emit('USER_INVITED', props),
    };
};
let cachedMetricsService;
let cachedTrackers = null;
export const useAdminUserTracking = () => {
    const { metricsService } = BasePageContext();
    if (!cachedTrackers || cachedMetricsService !== metricsService) {
        cachedMetricsService = metricsService;
        cachedTrackers = buildTrackers(metricsService);
    }
    return cachedTrackers;
};
//# sourceMappingURL=admin-tracking.js.map